import { useMemo } from 'react'
import { useFetchCustomerQuery } from 'modules/Customer'
import { getBillingContacts } from 'CustomerContacts/utils/getBillingContacts'

export function useBillingContacts(customerId: string) {
  const { customerDetails: customer } = useFetchCustomerQuery(customerId)

  return useMemo(() => {
    const contacts = customer?.contacts ?? []
    return getBillingContacts(contacts)
  }, [customer?.contacts])
}
